import { Injectable } from '@angular/core';
import { ApiService } from '@core/api.service';
import { Collection, CrudHttpService, CrudService, GetEntityModel, Item, PostEntityModel } from 'collection';
import { CollectionModel, ItemModel } from 'collection';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class EmployeesService {
  collection: CollectionModel;
  item: ItemModel;
  licensesInfoItem: ItemModel;
  accountSettingsItem: ItemModel;

  isReassign: PostEntityModel;
  workerReassign: PostEntityModel;
  reassignApprove: GetEntityModel;
  reassignCancel: GetEntityModel;

  isOpenSidebar: boolean = true;

  private _isOpenSidebar: BehaviorSubject<boolean> = new BehaviorSubject(this.isOpenSidebar);

  get $isOpenSidebar(): Observable<any> {
    return this._isOpenSidebar.asObservable();
  }

  toggleSidebar(): void {
    this.isOpenSidebar = !this.isOpenSidebar;
    this._isOpenSidebar.next(this.isOpenSidebar);
  }

  uploadAvatar(file: File) {
    const formData: FormData = new FormData();
    formData.append('avatar', file);

    return this.httpService.post({
      url: environment.apiUrl + '/v1/avatar',
      data: formData
    });
  }

  constructor(
    private httpService: CrudHttpService,
    private api: ApiService,
    private crud: CrudService
  ) {
    this.collection = new Collection({
      api: api.workers,
      params: {
        expand: 'full_name,avatars,wages'
      }
    });

    this.collection.loaded = true;
    this.collection.hardReloadAfter.updating = true;
    this.collection.loadByScrolling = false;

    this.item = new Item({
      api: this.api.workers,
      params: {
        expand: 'full_name,avatars,wages,default_salary_code,country,language'
      }
    });

    this.accountSettingsItem = new Item({
      api: this.api.accountSettings,
      params: {
        expand: 'country,language'
      }
    });

    this.licensesInfoItem = new Item({
      api: this.api.accountInfo
    });

    this.isReassign = this.crud.createPostEntity({ name: 'worker/is-reassign' });
    this.workerReassign = this.crud.createPostEntity({ name: 'worker/reassign' });
    this.reassignApprove = this.crud.createGetEntity({ name: 'reassign-approve' });
    this.reassignCancel = this.crud.createGetEntity({ name: 'reassign-cancel' });
  }
}
